import {
    needsAccountConfirmation,
    needsMFASelected,
    needsNewInvite,
    needsNewPassword,
    needsPasswordRecovery,
    needsSignIn,
    needsSignInConfirmed,
} from '/b2b/authentication/state/Auth.selectors';

import Component from './UnauthenticatedRoutes.component';
import UnauthenticatedPaths from './UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';
import fromState from '../../common/state/selectors';
import { matchPath } from 'react-router-dom';

const mapStateToProps = (state, { location }) => {
    return {
        isAuthenticated: fromState.Auth.isAuthenticated(state),
        needsAccountConfirmation:
            !matchPath(location.pathname, {
                path: UnauthenticatedPaths.SIGN_UP_CONFIRM,
            }) && needsAccountConfirmation(state),
        needsPasswordRecovery:
            !matchPath(location.pathname, { path: UnauthenticatedPaths.RESET_PASSWORD }) &&
            needsPasswordRecovery(state),
        needsSignInConfirmed:
            !matchPath(location.pathname, { path: UnauthenticatedPaths.SIGN_IN_CONFIRM }) &&
            needsSignInConfirmed(state),
        needsNewInvite:
            !matchPath(location.pathname, {
                path: UnauthenticatedPaths.SIGN_UP_RESEND,
            }) && needsNewInvite(state),
        needsNewPassword:
            !matchPath(location.pathname, {
                path: UnauthenticatedPaths.RECOVER_PASSWORD,
            }) && needsNewPassword(state),
        needsMFASelected:
            !matchPath(location.pathname, { path: UnauthenticatedPaths.SELECT_MFA }) &&
            needsMFASelected(state),
        needsSignIn:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SIGN_IN}`,
                exact: true,
            }) && needsSignIn(state),
    };
};

export default connect(mapStateToProps)(Component);
